import React, { memo } from 'react'
import capitalize from 'lodash/capitalize'
import moment from 'moment'
import { Tooltip } from 'transfix-ui/components/Tooltip'
import { Grid, Link, makeStyles, Typography } from 'transfix-ui/core'
import { FORMATS } from 'constants/datetime'
import { DISPLAY } from 'constants/display'
import { IIssueAutomationRuleFragment } from '../../../automation/graphql/IssueAutomationRuleFragment'
import { getRuleDescription } from '../../../automation/utils'

interface IAutomatedRuleRowProps {
  rule: IIssueAutomationRuleFragment
  issueTypeId: number
}

const useStyles = makeStyles(theme => ({
  row: {
    margin: `${theme.spacing(1)} 0px`,
    display: 'flex',
    width: '100%',
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  name: {
    display: 'inline-block',
  },
}))

export const AutomatedRuleRow = memo(({ issueTypeId, rule }: IAutomatedRuleRowProps) => {
  const classes = useStyles()
  const ruleType = rule.ruleAction === 'create' ? 'Open Issue' : 'Close Issue'
  const formattedUpdatedAt = moment(rule.updatedAt).format(FORMATS.monthDayYearTimeFormat24h)
  return (
    <div className={classes.row}>
      <Grid item xs={6} className={classes.item}>
        <div className={classes.name}>
          <Tooltip
            position='right'
            id={`rule-${rule.id}-description`}
            trigger={
              <Link
                href={`${__ROOT__}/issues/${issueTypeId}/automation?form=edit-rule-form&ruleId=${rule.id}`}
                target='_blank'>
                <Typography color='primary' variant='body1'>
                  {capitalize(rule.name)}
                </Typography>
              </Link>
            }>
            <>{getRuleDescription(rule)}</>
          </Tooltip>
        </div>
      </Grid>
      <Grid item xs={3} className={classes.item}>
        <Typography variant='body1'>{ruleType}</Typography>
      </Grid>
      <Grid item xs={3} className={classes.item}>
        <Typography variant='body1' component='span' display='block'>
          {rule.updatedBy?.fullName || DISPLAY.empty}
        </Typography>
        <Typography color='textSecondary' variant='caption'>
          {formattedUpdatedAt}
        </Typography>
      </Grid>
    </div>
  )
})
